interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/fa99bb9c62df4d6cdaf96fd6599da80a/bf3e389d3d8583412aec99bb39af84bb.png" 
              alt="Prakash Electricals Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`font-bold text-lg tracking-tight ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              PRAKASH ELECTRICALS [OPK]
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors hover:text-sky-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Home
            </button>
            <span className="text-sky-500">◆</span>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors hover:text-sky-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              About
            </button>
            <span className="text-sky-500">◆</span>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors hover:text-sky-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </button>
            <span className="text-sky-500">◆</span>
            <button onClick={() => scrollToSection('projects')} className={`text-sm font-medium transition-colors hover:text-sky-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Projects
            </button>
            <span className="text-sky-500">◆</span>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors hover:text-sky-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Testimonials
            </button>
            <span className="text-sky-500">◆</span>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors hover:text-sky-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </button>
          </div>

          <a href="tel:+918851640119" className="hidden md:flex items-center gap-2 px-4 py-2 border-2 border-sky-500 rounded-full text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white transition-all whitespace-nowrap cursor-pointer">
            <i className="ri-phone-line"></i>
            +91-8851640119
          </a>

          <button className="md:hidden text-2xl" onClick={() => scrollToSection('contact')}>
            <i className={`ri-menu-line ${scrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
